/* eslint-disable */
import Chart from 'react-apexcharts';
import { sum } from 'lodash';
import { formatTokenAmountCompact } from 'utils/FormatNumber';

interface Props {
  labels: Array<string>;
  series: Array<number>;
  suffix?: string;
  prefix?: string;
}

const PieChart = ({ labels, series, suffix, prefix }: Props) => {
  const options = {
    labels,
    dataLabels: {
      enabled: false,
    },
    tooltip: { enabled: false },
    legend: { show: false },

    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: '66%',
          labels: {
            show: true,
            value: {
              formatter(val: string) {
                return (
                  (prefix ? prefix : '') +
                  formatTokenAmountCompact(parseFloat(val)).toString() +
                  (suffix ? suffix : '')
                );
              },
            },
            total: {
              show: true,
              formatter(val: any) {
                return (
                  (prefix ? prefix : '') +
                  formatTokenAmountCompact(sum(val.globals.seriesTotals)) +
                  (suffix ? suffix : '')
                );
              },
            },
          },
        },
      },
    },
  };

  return <Chart options={options} series={series} type="donut" width="250" />;
};

export default PieChart;
